import { Box, Tag } from '@factorialco/deprecated-design-system'
import { ExternalUsersUserStatusFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  user: ExternalUsersUserStatusFragment
}

const UserStatus = ({ user }: Props) => {
  const statusConfig = {
    deactivated: {
      status: i18n.t('settings.external_users.status.inactive'),
      tagColor: Tag.Types.grey,
    },
    confirmed: {
      status: i18n.t('settings.external_users.status.confirmed'),
      tagColor: Tag.Types.viridian,
    },
    default: {
      status: i18n.t('settings.external_users.status.invited'),
      tagColor: Tag.Types.champagne,
    },
  }

  const userStatusKey = user.isDeactivated
    ? 'deactivated'
    : user.isConfirmed
    ? 'confirmed'
    : 'default'
  const userStatus = statusConfig[userStatusKey]

  return (
    <Box width="full" alignItems="flexEnd">
      <Tag leftItem="circle" showCircle type={userStatus.tagColor}>
        {userStatus.status}
      </Tag>
    </Box>
  )
}

export default UserStatus
